export const iconFontAwesomeDevicesHardwareSimCard = (
	<i className="fa-solid fa-sim-card"></i>
);
